import { useSortable } from "@dnd-kit/sortable";
import { DotsSixVerticalOutlined } from "@toddle-edu/ds-icons";
import { IconButton } from "@toddle-edu/ds-web";
import React, { memo } from "react";
import PropTypes from "prop-types";
import classes from "../../DragNDropSortableList.scss";
import classNames from "classnames";

/**
 * DragHandle - A drag handle component for sortable items
 *
 * This component renders an icon button that serves as the drag handle
 * for sortable list items. Users can click and drag this handle to reorder items.
 *
 * @component
 * @example
 * <DragNDropSortableList.DragHandle
 *   id="item-1"
 *   testId="drag-handle-1"
 * />
 */
const DragHandle = ({ testId, id, className }) => {
  const { listeners } = useSortable({
    id,
  });

  return (
    <IconButton
      icon={<DotsSixVerticalOutlined />}
      type="plain"
      variant="neutral"
      testId={testId}
      className={classNames(classes.dragIcon, className)}
      isCompact
      {...listeners}
    />
  );
};

DragHandle.propTypes = {
  /** Unique identifier for the sortable item this handle controls */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /** Test ID for testing purposes */
  testId: PropTypes.string,
  /** Additional CSS class name for custom styling */
  className: PropTypes.string,
};

DragHandle.defaultProps = {
  testId: undefined,
  className: "",
};

export default memo(DragHandle);
